<template>
  <footer
    class="flex justify-center bg-black bg-opacity-90 text-white w-full py-2"
  >
    <div class="text-sm">
      Copyright &copy; 2020 &bull; QuoteWorx &bull; All Rights Reserved
    </div>
  </footer>
</template>
